<template>
  <div class="home wrapper">
    <div class="wk_home_intro">
      <div class="wk_intro__row_left">
        <!-- todo remove this line, only for debug -->
        <h1 class="wk_intro__title" v-if="loggedIn">Welcome {{ name }},</h1>
        <h1 class="wk_intro__title">what would you like to do?</h1>
      </div>
      <div class="wk_intro__row_right">
        <ul class="wk_intro__nav">
          <li class="wk_intro__nav_item" v-if="!loggedIn">
            <router-link to="/login">
              <span class="wk_item_label">login</span>
              <span class="wk_item_arrow"></span>
            </router-link>
          </li>
          <li class="wk_intro__nav_item" v-if="loggedIn && (isAdmin || isSubsidiaryUser)">
            <router-link to="/collections">
              <span class="wk_item_label">manage collections</span>
              <span class="wk_item_arrow"></span>
            </router-link>
          </li>
          <li class="wk_intro__nav_item" v-if="loggedIn && isAdmin">
            <router-link to="/finishes">
              <span class="wk_item_label">manage finishes</span>
              <span class="wk_item_arrow"></span>
            </router-link>
          </li>
          <!--          <li class="wk_intro__nav_item" v-if="loggedIn">-->
          <!--            <router-link to="/colors">-->
          <!--              <span class="wk_item_label">manage colors</span>-->
          <!--              <span class="wk_item_arrow"></span>-->
          <!--            </router-link>-->
          <!--          </li>-->
          <li class="wk_intro__nav_item" v-if="loggedIn">
            <a href="https://abetlaminati.com/en/abet-toolkit-tutorial/" target="_blank">
              <span class="wk_item_label">tutorial</span>
              <span class="wk_item_arrow"></span>
            </a>
          </li>
          <li class="wk_intro__nav_item" v-if="loggedIn">
            <router-link to="/stocks">
              <span class="wk_item_label">stocks</span>
              <span class="wk_item_arrow"></span>
            </router-link>
          </li>
          <li class="wk_intro__nav_item" v-if="loggedIn">
            <router-link to="/producibility">
              <span class="wk_item_label">producibility</span>
              <span class="wk_item_arrow"></span>
            </router-link>
          </li>
          <li class="wk_intro__nav_item" v-if="loggedIn && isAdmin">
            <router-link to="/users">
              <span class="wk_item_label">manage users<span class="wk_item_label_new">new</span></span>
              <span class="wk_item_arrow"></span>
            </router-link>
          </li>

        </ul>
      </div>
    </div>
    <div v-if="loggedIn && (name === 'webkolm' || name === 'test@abetlaminati.com')" class="user-info">
      <div v-if="debug">
        <p>Status: authenticated</p>
        <p>Username: {{ name }}</p>
        <p v-if="cons && cons !== 'none' && cons !== 'all'">Subsidiary: {{ cons }}</p>
        <p v-if="isAdmin">Permissions: <b>admin</b></p>
        <p v-if="isSubsidiaryUser">Permissions: <b>subsidiary</b></p>
        <p v-if="isSalesUser">Permissions: <b>sales</b></p>
        <p v-if="provider">Authentication method: {{ provider }}</p>
      </div>
      <p class="debug-button" @click="debug = !debug">{{ debug ? 'hide' : 'show' }} account details</p>
    </div>
  </div>
</template>

<style lang="scss">
.wrapper {
  width: 90%;
  margin: 0 auto;
  max-width: 1280px;
}

.user-info {
  position: absolute;
  bottom: 0;
  right: 0;
  padding: 20px;
}

.home.wrapper {
  position: relative;
  height: calc(100vh - 64px);
  display: flex;
  align-items: center;
}

.wk_home_intro {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

h1.wk_intro__title {
  font-size: 40px;
  font-weight: 800;
}

.wk_intro__row_right,
.wk_intro__row_left {
  width: 50%;
}

ul.wk_intro__nav {
  list-style-type: none;
  margin: 0;
  font-size: 20px;
  text-decoration: none;
  padding: 0;
}

li.wk_intro__nav_item {
  margin-bottom: 20px;
}

li.wk_intro__nav_item > a {
  text-decoration: none;
  color: black;
  font-weight: 400;
  font-size: 30px;
  line-height: 1.3em;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

span.wk_item_arrow {
  display: block;
  width: 30px;
  height: 30px;
  background-image: url(../../public/img/abet_arrow.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  transition: transform 0.3s ease-in-out;
}

.wk_intro__nav_item > a:hover .wk_item_arrow {
  transform: translateX(-20%);
  transition: transform 0.3s ease-in-out;
}

.wk_item_label_new {
  font-size: 18px;
  color: grey;
  margin-left: 10px;
}

.v-sheet.v-theme--light.rounded-sm {
  width: 100%;

  form {
    display: flex;
    justify-content: flex-start;
    align-items: baseline;

    .v-input.v-input--horizontal.v-input--density-default.v-locale--is-ltr.v-text-field.v-input--plain-underlined {
      width: 80%;
      display: block;
      flex-shrink: 0;
    }

    .v-sheet.v-theme--light.rounded-sm,
    form,
    .v-btn.v-btn--block.v-btn--elevated.v-theme--light.bg-primary.v-btn--density-default.rounded-0.v-btn--size-default.v-btn--variant-elevated.mt-2 {
      width: 20%;
      flex-grow: 0;
      display: block;
    }
  }
}

.debug-button {
  font-size: 0.9rem;
  padding-top: 0.5rem;
  cursor: pointer;
  text-decoration: underline;
  text-align: right;
}
</style>

<script>
import {mapGetters} from "vuex";
import store from "@/store";
export default {
  name: "home",
  data: () => ({
    debug: false,
    snackbar: false,
    text: "",
  }),
  computed: {
    ...mapGetters("auth", ["loggedIn"]),
    ...mapGetters("auth", ["name"]),
    ...mapGetters("auth", ["provider"]),
    ...mapGetters("auth", ["token"]),
    ...mapGetters("auth", ["role"]),
    ...mapGetters("auth", ["isAdmin"]),
    ...mapGetters("auth", ["isSalesUser"]),
    ...mapGetters("auth", ["isSubsidiaryUser"]),
    ...mapGetters("auth", ["cons"]),
    ...mapGetters("auth", ["user"])
  },
  async mounted() {
    if (this.$route.meta.title) {
      document.title = this.$route.meta.title;
    }

    if (this.loggedIn && this.token && !this.role) {
      await store.dispatch("auth/role");
    }
  },
  async updated() {
    if (this.loggedIn && !this.role) {
      await store.dispatch("auth/role");
    }
  }
};
</script>
